import { render, staticRenderFns } from "./fullscreen-modal.vue?vue&type=template&id=3bd129eb&scoped=true&"
import script from "./fullscreen-modal.vue?vue&type=script&lang=ts&"
export * from "./fullscreen-modal.vue?vue&type=script&lang=ts&"
import style0 from "./fullscreen-modal.vue?vue&type=style&index=0&id=3bd129eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd129eb",
  null
  
)

export default component.exports